import { POST } from '@/api'
import { keyBy, mapValues } from 'lodash'
import detail from './detail'
import edit from './edit'
import options from './options'
import parts from './parts'

const initialLayout = {
  id: null,
  name: null,
  floors: [],
}

const initialFloor = {
  id: null,
  name: '',
  tables: [],
  parts: [],
  viewBox: '',
}

export default {
  namespaced: true,
  state: {
    byId: {},
    busy: false,
  },
  modules: {
    detail,
    edit,
    options,
    parts,
  },
  mutations: {
    set(state, layouts) {
      state.byId = keyBy(
        layouts.map(layout => ({ ...initialLayout, ...layout })),
        'id',
      )
    },
    setDetail(state, layout) {
      state.byId = {
        ...state.byId,
        [layout.id]: {
          ...initialLayout,
          ...layout,
          floors: layout.floors.map(floor => ({ ...initialFloor, ...floor })),
        },
      }
    },
    busy(state, value) {
      state.busy = value
    },
  },
  getters: {
    all(state) {
      return Object.keys(state.byId).map(id => state.byId[id])
    },
    nameById: ({ byId }) => mapValues(byId, ({ name }) => name),
    tableIdsById: ({ byId }) =>
      mapValues(byId, ({ floors }) =>
        floors.reduce((tableIds, floor) => tableIds.concat(floor.tables.map(table => table.id)), []),
      ),
  },
  actions: {
    async get(store) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/layouts/list')
      if (status === 200) {
        commit('set', data.layouts)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async getDetail(store, id) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/layouts/detail', { id })
      if (status === 200) {
        commit('setDetail', data.layout)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async copy(store, id) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)
      const { status, message } = await POST('/api/web/layouts/copy', { id })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)
      return status === 200
    },
    async delete(store, id) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)
      const { status, message } = await POST('/api/web/layouts/delete', { id })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)
      return status === 200
    },
  },
}
